import React from "react";
import ViewPageLayout from "../../../../../../../../ui/ViewPageLayout";
import HtmlEditor, { Toolbar, Item } from 'devextreme-react/html-editor';

const defaultParameters = {
  sizeValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
  fontValues: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
  headerValues: [false, 1, 2, 3, 4, 5],
  enabled: {
    enabled: true
  }
};

const ProgramDescriptionEdit = ({
                              disabled,
                              programId,
                              onFormChange,
                              programHtmlDescription,
  isEdited
                            }) => {
  const [description, setDescription] = React.useState(programHtmlDescription || "");

  const editorValueType = 'html';

  const onChange = (e) => {
    setDescription(e.value);
    onFormChange(e.value);
  };

  return (
    <ViewPageLayout header="Описание">
      <HtmlEditor
        mediaResizing={defaultParameters.enabled}
        valueType={editorValueType}
        value={description}
        onValueChanged={onChange}>
        <Toolbar>
          <Item formatName="undo" />
          <Item formatName="redo" />
          <Item formatName="separator" />
          <Item
            formatName="size"
            formatValues={defaultParameters.sizeValues}
          />
          <Item
            formatName="font"
            formatValues={defaultParameters.fontValues}
          />
          <Item formatName="separator" />
          <Item formatName="bold" />
          <Item formatName="italic" />
          <Item formatName="strike" />
          <Item formatName="underline" />
          <Item formatName="separator" />
          <Item formatName="alignLeft" />
          <Item formatName="alignCenter" />
          <Item formatName="alignRight" />
          <Item formatName="alignJustify" />
          <Item formatName="separator" />
          <Item
            formatName="header"
            formatValues={defaultParameters.headerValues}
          />
          <Item formatName="separator" />
          <Item formatName="orderedList" />
          <Item formatName="bulletList" />
          <Item formatName="separator" />
          <Item formatName="color" />
          <Item formatName="background" />
          <Item formatName="separator" />
          <Item formatName="link" />
          <Item formatName="image" />
          <Item formatName="separator" />
          <Item formatName="clear" />
          <Item formatName="codeBlock" />
          <Item formatName="blockquote" />
        </Toolbar>
        {/*HTMLReactParser(description)*/}
      </HtmlEditor>
    </ViewPageLayout>
  )
}

export default ProgramDescriptionEdit;

